"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionSubmit = exports.FunctionGetValueFromFieldReferenceWithFormat = exports.FunctionGetValueFromFieldReference = void 0;
const __1 = require("../../..");
const type_1 = require("../../../type");
const Common_Function_1 = require("../../../utils/Common.Function");
const Field_CheckError_1 = require("./Field.CheckError");
const Field_Function_1 = require("./Field.Function");
const FunctionGetValueFromFieldReference = (fields, FieldReference) => {
    let new_form = {};
    fields.forEach((first, firstIndex) => {
        if (first === null || first === void 0 ? void 0 : first.key) {
            const value = FieldReference.current[firstIndex];
            const selfValue = value[first.key];
            new_form[first.key] = selfValue;
            // inter futer I have also add 2 and 3 with format
        }
        else {
            const value = FieldReference.current[firstIndex];
            if (first === null || first === void 0 ? void 0 : first.name) {
                if ((first === null || first === void 0 ? void 0 : first.format) && !(value === null || value === void 0 ? void 0 : value.error)) {
                    new_form[first.name] = first === null || first === void 0 ? void 0 : first.format({ value });
                }
                else {
                    new_form[first.name] = value;
                }
            }
        }
    });
    return new_form;
};
exports.FunctionGetValueFromFieldReference = FunctionGetValueFromFieldReference;
const FunctionCheckHasObjectName = (object, name) => {
    return Object.keys(object).includes(name);
};
const FunctionGetValueFromFieldReferenceWithFormat = (fields, FieldReference) => {
    let new_form = {};
    fields.forEach((first, firstIndex) => {
        if (first === null || first === void 0 ? void 0 : first.key) {
            const value = FieldReference.current[firstIndex];
            let selfValue = (0, __1.FunctionCloneDeep)(value[first.key]);
            first.fields.forEach((second) => {
                if (second === null || second === void 0 ? void 0 : second.childKey) {
                    second.fields.forEach((third) => {
                        var _a, _b;
                        if ((third === null || third === void 0 ? void 0 : third.name) && (third === null || third === void 0 ? void 0 : third.format)) {
                            if (Array.isArray(selfValue)) {
                                // console.log("IN 1", {
                                //   second,
                                //   third,
                                //   selfValue,
                                // });
                                const check = (0, __1.FunctionCloneDeep)(selfValue === null || selfValue === void 0 ? void 0 : selfValue.map((fourth, fourthIndex) => {
                                    const thisFormatValue = (0, __1.FunctionCloneDeep)(selfValue[fourthIndex][second.childKey]);
                                    let thisLastStepValue = (0, __1.FunctionCloneDeep)(thisFormatValue.map((fifth) => {
                                        return Object.assign(Object.assign({}, fifth), { [third.name]: third === null || third === void 0 ? void 0 : third.format({
                                                value: fifth[third.name],
                                            }) });
                                    }));
                                    return Object.assign(Object.assign({}, fourth), { [second.childKey]: [...thisLastStepValue] });
                                }));
                                new_form[first.key] = check;
                            }
                            else {
                                // console.log("IN 2", {
                                //   second,
                                //   third,
                                //   selfValue,
                                //   c: selfValue[second.childKey],
                                // });
                                if (selfValue[second.childKey]) {
                                    //OBJECT ARRAY
                                    if (third === null || third === void 0 ? void 0 : third.format) {
                                        // console.log("IN 2.1", {
                                        //   second,
                                        //   third,
                                        //   selfValue,
                                        //   c: selfValue[second.childKey],
                                        // });
                                        if (Array.isArray(selfValue[second.childKey])) {
                                            // console.log("IN 2.1.1");
                                            selfValue = Object.assign(Object.assign({}, selfValue), { [second.childKey]: (_a = selfValue[second.childKey]) === null || _a === void 0 ? void 0 : _a.map((fourth) => {
                                                    if (third === null || third === void 0 ? void 0 : third.format) {
                                                        return Object.assign(Object.assign({}, fourth), { [third.name]: third === null || third === void 0 ? void 0 : third.format({
                                                                value: fourth[third.name],
                                                            }) });
                                                    }
                                                    else {
                                                        return Object.assign(Object.assign({}, fourth), { [third.name]: fourth[third.name] });
                                                    }
                                                }) });
                                        }
                                        else {
                                            // console.log("IN 2.1.2");
                                            if (third === null || third === void 0 ? void 0 : third.format) {
                                                selfValue = Object.assign(Object.assign({}, selfValue), { [second.childKey]: Object.assign(Object.assign({}, selfValue[second.childKey]), { [third.name]: third === null || third === void 0 ? void 0 : third.format({
                                                            value: selfValue[second.childKey][third.name],
                                                        }) }) });
                                            }
                                            else {
                                                selfValue = Object.assign(Object.assign({}, selfValue), { [second.childKey]: Object.assign(Object.assign({}, selfValue[second.childKey]), { [third.name]: selfValue[second.childKey][third.name] }) });
                                            }
                                        }
                                    }
                                    else {
                                        // console.log("IN 2.2");
                                        selfValue = Object.assign(Object.assign({}, selfValue), { [second.childKey]: Object.assign(Object.assign({}, selfValue[second.childKey]), { [third.name]: selfValue[second.childKey][third.name] }) });
                                    }
                                }
                                else {
                                    // console.log("IN 2.4");
                                    selfValue = Object.assign(Object.assign({}, selfValue), { [second.childKey]: selfValue[second.childKey].map((fourth) => {
                                            return Object.assign(Object.assign({}, fourth), { [third.name]: third === null || third === void 0 ? void 0 : third.format({
                                                    value: fourth[third.name],
                                                }) });
                                        }) });
                                }
                            }
                        }
                        else if (third === null || third === void 0 ? void 0 : third.name) {
                            if (Array.isArray(selfValue)) {
                                // console.log("IN 4 ", {
                                //   second,
                                //   third,
                                //   selfValue,
                                // });
                                selfValue = selfValue === null || selfValue === void 0 ? void 0 : selfValue.map((fourth, fourthIndex) => {
                                    const thisFormatValue = (0, __1.FunctionCloneDeep)(selfValue[fourthIndex][second.childKey]);
                                    return Object.assign(Object.assign({}, fourth), { [second.childKey]: thisFormatValue.map((fifth) => {
                                            return Object.assign(Object.assign({}, fifth), { [third.name]: fifth[third.name] });
                                        }) });
                                });
                            }
                            else {
                                // console.log("IN 5", {
                                //   second,
                                //   third,
                                //   selfValue,
                                //   v: selfValue[second.childKey],
                                // });
                                if (selfValue[second.childKey]) {
                                    // console.log("5.1");
                                    if (Array.isArray(selfValue[second.childKey])) {
                                        // console.log("5.1.1");
                                        selfValue = Object.assign(Object.assign({}, selfValue), { [second.childKey]: (_b = selfValue[second.childKey]) === null || _b === void 0 ? void 0 : _b.map((fourth) => {
                                                return Object.assign(Object.assign({}, fourth), { [third.name]: fourth[third.name] });
                                            }) });
                                    }
                                    else {
                                        //OBJECT OBJECT
                                        // console.log("5.1.2");
                                        if (third === null || third === void 0 ? void 0 : third.format) {
                                            // console.log("5.1.2.1");
                                            selfValue = Object.assign(Object.assign({}, selfValue), { [second.childKey]: Object.assign(Object.assign({}, selfValue[second.childKey]), { [third.name]: third === null || third === void 0 ? void 0 : third.format({
                                                        value: selfValue[second.childKey][third.name],
                                                    }) }) });
                                        }
                                        else {
                                            // console.log("5.1.2.2");
                                            selfValue = Object.assign(Object.assign({}, selfValue), { [second.childKey]: Object.assign(Object.assign({}, selfValue[second.childKey]), { [third.name]: selfValue[second.childKey][third.name] }) });
                                        }
                                    }
                                }
                                else {
                                    // console.log("5.2");
                                    selfValue = Object.assign(Object.assign({}, selfValue), { [second.childKey]: selfValue[second.childKey].map((fourth) => {
                                            return Object.assign(Object.assign({}, fourth), { [third.name]: fourth[third.name] });
                                        }) });
                                }
                            }
                        }
                    });
                }
                else {
                    if (second === null || second === void 0 ? void 0 : second.name) {
                        if ((second === null || second === void 0 ? void 0 : second.format) && !(selfValue === null || selfValue === void 0 ? void 0 : selfValue.error)) {
                            if (Array.isArray(selfValue)) {
                                selfValue = selfValue === null || selfValue === void 0 ? void 0 : selfValue.map((third) => {
                                    if (FunctionCheckHasObjectName(third, second.name)) {
                                        const thisFormatValue = second === null || second === void 0 ? void 0 : second.format({
                                            value: third[second.name],
                                        });
                                        return Object.assign(Object.assign({}, third), { [second.name]: thisFormatValue });
                                    }
                                });
                            }
                            else {
                                const thisFormatValue = second === null || second === void 0 ? void 0 : second.format({
                                    value: selfValue[second.name],
                                });
                                selfValue = Object.assign(Object.assign({}, selfValue), { [second.name]: thisFormatValue });
                            }
                            new_form = Object.assign(Object.assign({}, new_form), { [first.key]: (0, __1.FunctionCloneDeep)(selfValue) });
                        }
                        else {
                            new_form = Object.assign(Object.assign({}, new_form), { [first.key]: (0, __1.FunctionCloneDeep)(selfValue) });
                        }
                    }
                }
            });
        }
        else {
            const value = FieldReference.current[firstIndex];
            if (first === null || first === void 0 ? void 0 : first.name) {
                if ((first === null || first === void 0 ? void 0 : first.format) && !(value === null || value === void 0 ? void 0 : value.error)) {
                    new_form[first.name] = first === null || first === void 0 ? void 0 : first.format({ value });
                }
                else {
                    new_form[first.name] = value;
                }
            }
        }
    });
    return new_form;
};
exports.FunctionGetValueFromFieldReferenceWithFormat = FunctionGetValueFromFieldReferenceWithFormat;
const FunctionSubmit = (fields, FieldReference, onSubmit, renderAlertError, error, FunctionReset, resetAfterSubmit, showErrorAlert, loadData, validateDataNoChange) => {
    if (fields && FieldReference && onSubmit) {
        const thisValue = (0, exports.FunctionGetValueFromFieldReferenceWithFormat)(fields, FieldReference);
        const isError = (0, Field_CheckError_1.FunctionCheckIsError)(thisValue, error);
        if ((isError === null || isError === void 0 ? void 0 : isError.error) && error === type_1.TYPE_ERROR_NORMAL && showErrorAlert) {
            if (renderAlertError) {
                renderAlertError({
                    message: isError.message,
                    name: isError.name,
                    error: isError,
                });
                return;
            }
            else {
                alert(`name: ${isError.name} - error : ${isError.message}`);
                return;
            }
        }
        if ((isError === null || isError === void 0 ? void 0 : isError.length) > 0 && error === type_1.TYPE_ERROR_ARRAY && showErrorAlert) {
            if (renderAlertError) {
                renderAlertError({ error: isError });
                return;
            }
            else {
                alert(`${isError === null || isError === void 0 ? void 0 : isError.map((e) => {
                    return `name : ${e.name} - error : ${e.message}`;
                })}`);
                return;
            }
        }
        const result = (0, Field_Function_1.FunctionRemoveUndefinedKey)(thisValue);
        let comparisionA = (0, __1.FunctionCloneDeep)(result);
        let comparisionB = (0, __1.FunctionCloneDeep)(loadData);
        if ((validateDataNoChange === null || validateDataNoChange === void 0 ? void 0 : validateDataNoChange.length) > 0) {
            comparisionA = (0, __1.FunctionSelectFields)(result, validateDataNoChange);
            comparisionB = (0, __1.FunctionSelectFields)(loadData, validateDataNoChange);
        }
        const isEqual = (0, __1.FunctionCheckIsEqual)((0, Common_Function_1.FunctionRemoveEmptyValue)(comparisionA), (0, Common_Function_1.FunctionRemoveEmptyValue)(comparisionB));
        onSubmit(result, isEqual, loadData, (0, Common_Function_1.FunctionRemoveEmptyValue)(comparisionA), (0, Common_Function_1.FunctionRemoveEmptyValue)(comparisionB));
        if (resetAfterSubmit) {
            FunctionReset();
        }
    }
    else {
        return;
    }
};
exports.FunctionSubmit = FunctionSubmit;
